import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import GpWebUpdatePassword from '../../../components/gp-web-update-password/gp-web-update-password'
import './gp-web-update-password-page.css';

export class GpWebUpdatePasswordPage extends Component {
  constructor(props) {
    super()
  }

  render() {
    return (
      <div className='page'>
        <GpWebUpdatePassword {...this.props} />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  passwordError: state.updatePassword.error,
})

const mapDispatchToProps = dispatch => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
})

export default connect(mapStateToProps, mapDispatchToProps)(
  translate()(GpWebUpdatePasswordPage),
)



// WEBPACK FOOTER //
// ./src/containers/pages/gp-web-update-password-page/gp-web-update-password-page.js